import { render, staticRenderFns } from "./Webinars.vue?vue&type=template&id=2f051967"
import script from "./Webinars.vue?vue&type=script&lang=js"
export * from "./Webinars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports